<template>
  <div class="app-container">
    <!-- 顶部筛选栏 -->
    <div class="filter-bar">
      <div class="date-filter">
        <span>费用日期</span>
        <el-date-picker
          v-model="queryParams.signDate"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 240px"
        ></el-date-picker>
      </div>
      <div class="btn-area">
        <el-button type="primary" @click="handleQuery">查询</el-button>
        <el-button @click="resetQuery">重置</el-button>
        <el-button type="primary" @click="handleAddExtra">新增额外收支</el-button>
      </div>
    </div>

    <!-- 主容器 -->
    <div class="container">
      <!-- 左侧合伙人列表 -->
      <div class="sidebar">
        <h2>合伙人列表</h2>
        <div class="partner-sort">
          <span>阿米巴收入排序</span>
          <i class="el-icon-bottom"></i>
        </div>

        <div class="partner-table-container" ref="partnerTableContainer" @scroll="handlePartnerScroll">
          <el-table
            ref="partnerTable"
            :data="partnerList"
            highlight-current-row
            @row-click="handlePartnerRowClick"
            class="partner-table"
            :show-header="true"
          >
            <el-table-column prop="partnerName" label="合伙人" min-width="100">
              <template slot-scope="scope">
                <span class="partner-name">{{ scope.row.partnerName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="amoebaIncome" label="阿米巴收入（元）" min-width="120" align="right">
              <template slot-scope="scope">
                <span>{{ amountFormat(scope.row.amoebaIncome) }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="partnerLoading" class="loading-more">加载中...</div>
          <div v-if="!partnerHasMore && partnerList.length > 0" class="no-more">没有更多了</div>
        </div>
      </div>

      <!-- 右侧内容区 -->
      <div class="content">
        <!-- 数据概览卡片 -->
        <div class="stats-row">
          <div class="stat-card">
            <div class="stat-title">总收入（元）</div>
            <div class="stat-value">{{ amountFormat(summaryData.totalIncome) }}</div>
            <div class="stat-desc">合同: {{ amountFormat(summaryData.contractIncome) }} | 额外: {{ amountFormat(summaryData.extraIncome) }}</div>
          </div>
          <div class="stat-card">
            <div class="stat-title">总支出（元）</div>
            <div class="stat-value">{{ amountFormat(summaryData.totalExpense) }}</div>
            <div class="stat-desc">合同: {{ amountFormat(summaryData.contractExpense) }} | 额外: {{ amountFormat(summaryData.extraExpense) }}</div>
          </div>
          <div class="stat-card">
            <div class="stat-title">阿米巴收入（元）</div>
            <div class="stat-value">{{ amountFormat(summaryData.amoebaIncome) }}</div>
            <div class="stat-desc">收入 - 支出</div>
          </div>
        </div>

        <!-- 标签页 -->
        <div class="tabs">
          <el-tabs v-model="activeTab" @tab-click="handleTabClick">
            <el-tab-pane label="项目收支" name="project"></el-tab-pane>
            <el-tab-pane label="额外收支" name="extra"></el-tab-pane>
          </el-tabs>
        </div>

        <!-- 项目收支表格 -->
        <div v-show="activeTab === 'project'" class="table-container">
          <el-table v-loading="loading" :data="projectList" border>
            <el-table-column label="合同编号" min-width="120" align="center">
              <template slot-scope="scope">
                {{ scope.row.contractNum }}
              </template>
            </el-table-column>
            <el-table-column label="客户名称" min-width="150" align="center" prop="customerName" show-overflow-tooltip/>
            <el-table-column label="费用类型" min-width="80" align="center" prop="feeTypeDesc"/>
            <el-table-column label="金额（元）" min-width="100" align="right">
              <template slot-scope="scope">
                <span>{{ amountFormat(scope.row.amount) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="备注" min-width="120" align="center" prop="remark" show-overflow-tooltip/>
            <el-table-column label="费用时间" min-width="150" align="center" prop="createTime"/>
          </el-table>
          <pagination
            v-show="projectTotal > 0"
            :total="projectTotal"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getProjectList"
          />
        </div>

        <!-- 额外收支表格 -->
        <div v-show="activeTab === 'extra'" class="table-container">
          <el-table v-loading="loading" :data="extraList" border>
            <el-table-column label="费用日期" min-width="150" align="center" prop="balanceDate"/>
            <el-table-column label="费用类型" min-width="100" align="center" prop="feeTypeDesc"/>
            <el-table-column label="金额（元）" min-width="120" align="right">
              <template slot-scope="scope">
                <span>{{ amountFormat(scope.row.amount) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="备注" min-width="150" align="center" prop="remark" show-overflow-tooltip/>
            <el-table-column label="创建人" min-width="100" align="center" prop="creatorName"/>
            <el-table-column label="创建时间" min-width="150" align="center" prop="createTime"/>
            <el-table-column label="操作" min-width="120" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" v-hasPermi="['crm:partnerIncomeExpenditure:edit']" @click="handleEditExtra(scope.row)">编辑</el-button>
                <el-button type="text" v-hasPermi="['crm:partnerIncomeExpenditure:delete']" @click="handleDeleteExtra(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-show="extraTotal > 0"
            :total="extraTotal"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getExtraList"
          />
        </div>
      </div>
    </div>

    <!-- 新增/编辑额外收支弹窗 -->
    <el-dialog :title="extraDialogTitle" :visible.sync="extraDialogVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="extraForm" :rules="extraRules" ref="extraFormRef" label-width="100px">
        <el-form-item label="费用日期" prop="balanceDate">
          <el-date-picker
            v-model="extraForm.balanceDate"
            type="date"
            placeholder="请选择费用日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="费用类型" prop="feeType">
          <el-radio-group v-model="extraForm.feeType">
            <el-radio label="1">收入</el-radio>
            <el-radio label="2">支出</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="合伙人" prop="partnerId">
          <el-select v-model="extraForm.partnerId" filterable placeholder="请选择合伙人" style="width: 100%" @change="handlePartnerChange">
            <el-option
              v-for="item in partnerOptions"
              :key="item.partnerId"
              :label="item.partnerName"
              :value="item.partnerId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="金额（元）" prop="amount">
          <el-input-number v-model="extraForm.amount" :min="0" :precision="2" placeholder="请输入金额" style="width: 100%"/>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="extraForm.remark" :maxlength="200" show-word-limit placeholder="请输入备注"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="extraDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmExtra">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listPagePartnerIncomeExpenditure, listPartnerAll, listPageProjectIncomeExpenditure, listPageExtraIncomeExpenditure, getPartnerSummary, createExtraIncomeExpenditure, updateExtraIncomeExpenditure, delExtraIncomeExpenditure } from "@/api/crm/partnerIncomeExpenditure";
import { amountFormat } from '@/utils/index';
import { mapState } from "vuex";
import Pagination from "@/components/Pagination";

export default {
  name: "PartnerIncomeExpenditureManage",
  components: {
    Pagination
  },
  data() {
    return {
      amountFormat,
      loading: true,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        signDate: [],
        signDateStart: null,
        signDateEnd: null,
        partnerId: null,
        partnerPageNum: 1,
        partnerPageSize: 10
      },
      // 合伙人列表
      partnerList: [],
      partnerTotal: 0,
      // 选中的合伙人
      currentPartner: null,
      // 活跃标签页
      activeTab: 'project',
      // 项目收支列表
      projectList: [],
      projectTotal: 0,
      // 额外收支列表
      extraList: [],
      extraTotal: 0,
      // 汇总数据
      summaryData: {
        totalIncome: 0,
        totalExpense: 0,
        amoebaIncome: 0,
        contractIncome: 0,
        contractExpense: 0,
        extraIncome: 0,
        extraExpense: 0
      },
      // 额外收支弹窗
      extraDialogVisible: false,
      extraDialogTitle: '新增额外收支',
      extraForm: {
        id: null,
        balanceDate: null,
        feeType: '1',
        partnerId: null,
        partnerName: null,
        dingtalkDeptName: null,
        amount: null,
        remark: ''
      },
      extraRules: {
        balanceDate: [{ required: true, message: '请选择费用日期', trigger: 'change' }],
        feeType: [{ required: true, message: '请选择费用类型', trigger: 'change' }],
        partnerId: [{ required: true, message: '请选择合伙人', trigger: 'change' }],
        amount: [{ required: true, message: '请输入金额', trigger: 'blur' }]
      },
      // 合伙人下拉选项
      partnerOptions: [],
      // 合伙人列表滚动加载
      partnerLoading: false,
      partnerHasMore: true
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  created() {
    this.getPartnerList();
  },
  methods: {
    // 获取合伙人列表
    getPartnerList(isReset = true) {
      if (this.partnerLoading || (!isReset && !this.partnerHasMore)) return;
      this.partnerLoading = true;
      if (isReset) {
        this.queryParams.partnerPageNum = 1;
        this.partnerHasMore = true;
      }
      listPagePartnerIncomeExpenditure({
        pageNum: this.queryParams.partnerPageNum,
        pageSize: this.queryParams.partnerPageSize,
        signDateStart: this.queryParams.signDateStart,
        signDateEnd: this.queryParams.signDateEnd
      }).then(response => {
        const rows = response.rows || [];
        if (isReset) {
          this.partnerList = rows;
        } else {
          this.partnerList = [...this.partnerList, ...rows];
        }
        this.partnerTotal = response.total;
        this.partnerHasMore = this.partnerList.length < this.partnerTotal;
        this.queryParams.partnerPageNum++;
        // 初始加载时默认选中第一个合伙人
        if (isReset && this.partnerList.length > 0 && !this.currentPartner) {
          this.currentPartner = this.partnerList[0];
          this.queryParams.partnerId = this.currentPartner.partnerId;
          this.$nextTick(() => {
            if (this.$refs.partnerTable) {
              this.$refs.partnerTable.setCurrentRow(this.partnerList[0]);
            }
          });
          this.getSummary();
          if (this.activeTab === 'extra') {
            this.getExtraList();
          } else {
            this.getProjectList();
          }
        }
        this.loading = false;
        this.partnerLoading = false;
      }).catch(() => {
        this.partnerLoading = false;
      });
    },
    // 合伙人列表滚动加载
    handlePartnerScroll(e) {
      const target = e.target;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollHeight - scrollTop - clientHeight < scrollHeight * 0.2) {
        this.getPartnerList(false);
      }
    },
    // 获取汇总数据
    getSummary() {
      getPartnerSummary({
        partnerId: this.queryParams.partnerId,
        signDateStart: this.queryParams.signDateStart,
        signDateEnd: this.queryParams.signDateEnd
      }).then(response => {
        this.summaryData = response.data || this.summaryData;
      });
    },
    // 获取项目收支列表
    getProjectList() {
      this.loading = true;
      let params = {
        ...this.queryParams,
        partnerId: this.queryParams.partnerId
      };
      if (params.signDate && params.signDate.length > 1) {
        params.signDateStart = params.signDate[0];
        params.signDateEnd = params.signDate[1];
      }
      listPageProjectIncomeExpenditure(params).then(response => {
        this.projectList = response.rows || [];
        this.projectTotal = response.total;
        this.loading = false;
      });
    },
    // 获取额外收支列表
    getExtraList() {
      this.loading = true;
      let params = {
        ...this.queryParams,
        partnerId: this.queryParams.partnerId
      };
      if (params.signDate && params.signDate.length > 1) {
        params.signDateStart = params.signDate[0];
        params.signDateEnd = params.signDate[1];
      }
      listPageExtraIncomeExpenditure(params).then(response => {
        this.extraList = response.rows || [];
        this.extraTotal = response.total;
        this.loading = false;
      });
    },
    // 合伙人行点击
    handlePartnerRowClick(row) {
      this.currentPartner = row;
      this.queryParams.partnerId = row.partnerId;
      this.queryParams.pageNum = 1;
      this.getSummary();
      if (this.activeTab === 'project') {
        this.getProjectList();
      } else {
        this.getExtraList();
      }
    },
    // 标签页切换
    handleTabClick() {
      this.queryParams.pageNum = 1;
      if (this.activeTab === 'project') {
        this.getProjectList();
      } else {
        this.getExtraList();
      }
    },
    // 搜索
    handleQuery() {
      if (this.queryParams.signDate && this.queryParams.signDate.length > 1) {
        this.queryParams.signDateStart = this.queryParams.signDate[0];
        this.queryParams.signDateEnd = this.queryParams.signDate[1];
      } else {
        this.queryParams.signDateStart = null;
        this.queryParams.signDateEnd = null;
      }
      this.queryParams.pageNum = 1;
      this.queryParams.partnerPageNum = 1;
      this.currentPartner = null;
      if (this.$refs.partnerTable) {
        this.$refs.partnerTable.setCurrentRow(null);
      }
      // getPartnerList 内部会自动选中第一个合伙人并调用 getSummary 和对应的列表
      this.getPartnerList(true);
    },
    // 重置
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        signDate: [],
        signDateStart: null,
        signDateEnd: null,
        partnerId: null,
        partnerPageNum: 1,
        partnerPageSize: 10
      };
      this.currentPartner = null;
      if (this.$refs.partnerTable) {
        this.$refs.partnerTable.setCurrentRow(null);
      }
      // getPartnerList 内部会自动选中第一个合伙人并调用 getSummary 和对应的列表
      this.getPartnerList(true);
    },
    // 新增额外收支
    handleAddExtra() {
      this.extraDialogTitle = '新增额外收支';
      this.extraForm = {
        id: null,
        balanceDate: null,
        feeType: '1',
        partnerId: null,
        partnerName: null,
        dingtalkDeptName: null,
        amount: null,
        remark: ''
      };
      this.getPartnerOptions().then(() => {
        // 下拉选项加载完成后，如果当前有选中合伙人，设置对应信息
        if (this.currentPartner) {
          const partner = this.partnerOptions.find(p => p.partnerId === this.currentPartner.partnerId);
          if (partner) {
            this.extraForm.partnerId = partner.partnerId;
            this.extraForm.partnerName = partner.partnerName;
            this.extraForm.dingtalkDeptName = partner.dingtalkDeptName;
          }
        }
      });
      this.extraDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.extraFormRef.clearValidate();
      });
    },
    // 编辑额外收支
    handleEditExtra(row) {
      this.extraDialogTitle = '编辑额外收支';
      this.extraForm = {
        id: row.id,
        balanceDate: row.balanceDate,
        feeType: String(row.feeType),
        partnerId: row.partnerId,
        partnerName: row.partnerName,
        dingtalkDeptName: row.dingtalkDeptName || null,
        amount: row.amount,
        remark: row.remark
      };
      this.getPartnerOptions();
      this.extraDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.extraFormRef.clearValidate();
      });
    },
    // 获取合伙人下拉选项
    getPartnerOptions() {
      return listPartnerAll().then(response => {
        this.partnerOptions = response.data || [];
      });
    },
    // 合伙人下拉选择变化
    handlePartnerChange(partnerId) {
      const partner = this.partnerOptions.find(item => item.partnerId === partnerId);
      if (partner) {
        this.extraForm.partnerName = partner.partnerName;
        this.extraForm.dingtalkDeptName = partner.dingtalkDeptName;
      }
    },
    // 删除额外收支
    handleDeleteExtra(row) {
      this.$confirm('删除后将无法恢复，是否确认删除该记录?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delExtraIncomeExpenditure({ id: row.id }).then(response => {
          this.msgSuccess('删除成功');
          this.getPartnerList();
          this.getExtraList();
          this.getSummary();
        });
      });
    },
    // 确认额外收支
    confirmExtra() {
      this.$refs.extraFormRef.validate(valid => {
        if (valid) {
          const loading = this.$loading({ lock: true, text: '加载中', spinner: 'el-icon-loading' });
          const action = this.extraForm.id ? updateExtraIncomeExpenditure : createExtraIncomeExpenditure;
          action(this.extraForm).then(response => {
            this.extraDialogVisible = false;
            this.msgSuccess('操作成功');
            this.getPartnerList();
            this.getSummary();
            this.getProjectList();
            this.getExtraList();
          }).finally(() => {
            loading.close();
          });
        }
      });
    },
    // 跳转合同详情
    toContractDetail(row) {
      window.open('/crm/contract/detail/' + row.contractId, '_blank');
    }
  }
};
</script>

<style scoped>
.filter-bar {
  padding: 16px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.date-filter {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #4b5563;
}
.btn-area {
  display: flex;
  gap: 8px;
}
.container {
  display: flex;
  min-height: calc(100vh - 200px);
  position: relative;
}
.sidebar {
  width: 280px;
  border-right: 1px solid #e5e7eb;
  padding: 16px;
  background: #fff;
  height: calc(100vh - 120px);
}
.sidebar h2 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
}
.partner-sort {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.partner-table {
  width: 100%;
  margin-bottom: 12px;
}
.partner-table >>> .el-table__row {
  cursor: pointer;
}
.partner-table >>> .el-table__row.current-row {
  background-color: #f5f7fa;
}
.partner-table-container {
  height: calc(100vh - 280px);
  overflow-y: auto;
}
.loading-more,
.no-more {
  text-align: center;
  padding: 12px;
  color: #909399;
  font-size: 12px;
}
.partner-name {
  font-weight: 500;
}
.sort-tip {
  background: #fef3c7;
  color: #92400e;
  padding: 8px;
  border-radius: 4px;
  font-size: 12px;
  margin-top: 12px;
}
.content {
  flex: 1;
  padding: 16px;
  background: #fff;
}
.stats-row {
  display: flex;
  gap: 24px;
  margin-bottom: 24px;
}
.stat-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  padding: 16px;
  min-width: 200px;
  flex: 1;
}
.stat-title {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 8px;
}
.stat-value {
  font-size: 24px;
  font-weight: 600;
  color: #111827;
}
.stat-desc {
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
}
.tabs {
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 16px;
}
.table-container {
  margin-bottom: 16px;
}
.tip-box {
  position: absolute;
  right: 16px;
  top: 180px;
  width: 220px;
  background: #fef3c7;
  color: #92400e;
  padding: 12px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.6;
}
</style>
